module.exports = __webpack_public_path__ + "img/EX1_recog_happy.0d8c2108.jpg";